<template>
	<div class="sales_param flex flex_items_center w_100">
		<div class="flex flex_column" style="width: 30%">
			<md-radio v-model="selectedType" :value="typeValue" @change="selectType" style="margin: 0">
				{{ $t(nameTranslationKey) }}
			</md-radio>
			<a v-if="formulaUrl" class="font_sm" :href="formulaUrl" target="_blank">
				({{ $t("common.button.showFormula") }})
			</a>
		</div>
		<div class="margin_r flex flex_end" style="width: 30%">
			<div v-if="suggestedPrice" class="flex flex_items_center">
				<span>{{ suggestedValueFormatted }}</span>
				<div class="fa_box"
					 :class="{'primary_color': suggestedPrice, 'disabled': !isSelected }"
					 @click="applySuggestedValue"
				>
					<i class="fa fa-share"/>
				</div>
				<el-tooltip v-if="showUnknownRatingHint"
							placement="top" :open-delay="300"
							:content="$t('seller.priceSuggestion.unknownRating.tooltip')"
				>
					<i class="fa fa-warning text-warning"/>
				</el-tooltip>
			</div>
			<div v-else :class="{'disabled': !isSelected}">
				<md-button :class="{'md-primary': isSelected }" :disabled="!isSelected" @click="requestSuggestedPrice">
					{{ $t("seller.upload.salesParam.button.suggestedPrice") }}
				</md-button>
			</div>
		</div>
		<div class="flex flex_center" style="width: 45%">
			<div class="fa_box margin_r" :class="{'disabled': !isSelected}" @click="clearValue" >
				<span class="close_icon">x</span>
			</div>
			<md-field :class="[{ 'md-error': error }]">
				<label>{{ $t(nameTranslationKey) }}</label>
				<MoneyAmountInput v-model="value"
								  @input="updateValue"
								  :as-percentage-rate="true"
								  :class="{'accent_color': isSelected, 'inactive_color': !isSelected }"
								  :disabled="!isSelected"
				/>
				<span v-if="error" class="validation-error">{{ error }}</span>
			</md-field>
		</div>
	</div>
</template>

<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput.vue";
import {formatAsPercentage} from "@/common/format";

export default {
	components: { MoneyAmountInput },
	props: {
		value: { type: Number, default: null },
		selectedType: { type: String },
		typeValue: { type: String },
		suggestedPrice: { type: Number, default: null },
		showUnknownRatingHint: { type: Boolean, default: false },
		nameTranslationKey: { type: String },
		formulaUrl: { type: String },
		error: { type: String, default: null },
	},
	computed: {
		isSelected() {
			return this.selectedType === this.typeValue;
		},
		suggestedValueFormatted() {
			return formatAsPercentage(this.suggestedPrice);
		}
	},
	methods: {
		selectType() {
			this.$emit("select", this.selectedType)
		},
		requestSuggestedPrice() {
			this.$emit("suggest");
		},
		applySuggestedValue() {
			if (this.isSelected) {
				this.updateValue(this.suggestedPrice);
			}
		},
		clearValue() {
			if (this.isSelected) {
				this.updateValue(null);
			}
		},
		updateValue(newValue) {
			this.value = newValue;
			this.$emit("input", newValue);
		},
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base_variables.scss";

.sales_param {
	$fa-box-size: 21px;
	$fa-box-icon-margin: 5px;

	.fa_box {
		min-height: $fa-box-size;
		min-width: $fa-box-size;
		margin-left: $fa-box-icon-margin;
		text-align: center;
		line-height: $fa-box-size;
		border-radius: 4px;
		border: 1px solid $border-color-gray-light;
		cursor: pointer;

		i {
			font-size: 15px;
		}

		&.disabled {
			background: $inactive-color;
		}

		&:hover:not(.disabled) {
			border-color: $accent-color-hover;
		}

		&.primary_color {
			border: none;
			color: #ffffff;

			&:not(.disabled) {
				background: $accent-background-color;
				&:hover {
					background: $accent-background-color-hover;
				}
			}
		}
	}

	.disabled {
		cursor: not-allowed;
	}

	.fa-warning {
		margin-left: $fa-box-icon-margin;
		font-size: $fa-box-size;
	}

}
</style>
